module.exports = __webpack_public_path__ + "static/media/punggol.939e6b98.png";